import Model from 'flarum/common/Model';

/**
 * Modelo cliente de `umbral-group-requests`.
 *
 * HACE FALTA AUNQUE NADIE LO INSTANCIE A MANO. `Store.pushObject` descarta los recursos cuyo
 * `type` no tiene modelo registrado, y la notificacion de la campanita llega con la solicitud
 * como `subject` incluido: sin este registro, `notification.subject()` seria null y el aviso
 * quedaria a medias. Tambien es lo que permite que la cola del panel lea `request.user()` en
 * vez de rebuscar en `included`.
 *
 * En `common/` y no en `forum/` porque lo usan los dos frontends: la campanita en el foro y la
 * cola en el admin.
 */
export default class GroupRequest extends Model {
  status = Model.attribute<string>('status');

  /**
   * Las respuestas del Form B.
   *
   * NO SE PUEDE LLAMAR `payload`, aunque la columna de la base si se llame asi.
   * `Store.pushPayload()` acaba con `result.payload = payload` (core
   * `js/src/common/Store.ts:109`), y cuando la respuesta trae UN solo recurso `result` es este
   * modelo: esa linea sustituye el accessor por el JSON crudo. El sintoma es cruel — todo
   * funciona hasta el primer `save()`, y a partir de ahi el render muere con «payload is not a
   * function». Ver la nota larga en `GroupRequestSerializer`.
   */
  answers = Model.attribute<Record<string, any> | undefined>('answers');

  createdAt = Model.attribute<Date | undefined>('createdAt', (value) => Model.transformDate(value as string | undefined));
  decidedAt = Model.attribute<Date | undefined>('decidedAt', (value) => Model.transformDate(value as string | undefined));
  revision = Model.attribute<number>('revision');
  history = Model.attribute<
    Array<{
      id: number;
      action: string;
      note: string | null;
      mailStatus: string | null;
      createdAt: string | null;
      actor: string | null;
    }>
  >('history');

  user = Model.hasOne<any>('user');
  decidedBy = Model.hasOne<any>('decidedBy');

  /**
   * La ruta REAL, que no se deduce del tipo.
   *
   * `Model.apiEndpoint()` arma la URL como `/<type>/<id>`, y aqui eso daria
   * `/api/umbral-group-requests/3` — una ruta que no existe. El tipo JSON:API lleva guion
   * porque es un identificador de recurso; la ruta lleva barra porque va prefijada por
   * extension (`/umbral/...`, como `fof/doorman` usa `/fof/...`). Sin este override,
   * `request.save({status})` desde la cola del panel se iria a un 404.
   */
  protected apiEndpoint(): string {
    return '/umbral/group-requests' + ('id' in this.data ? '/' + this.data.id : '');
  }
}
